export const getArrayDepth = (value: unknown[]): number =>
    Array.isArray(value) ? 1 + Math.max(...value.map(getArrayDepth)) : 0;